import type { ButtonHTMLAttributes } from 'react';
import { cx } from '../internal/tone';

export interface IconButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'children'> {
  icon: string;
  /**
   * OBRIGATÓRIO: é o nome acessível do botão. Um ícone sozinho não diz nada a
   * quem usa leitor de tela — e pouco a quem não usa.
   */
  label: string;
  onClick?: () => void;
  /** Desenha moldura quando o botão precisa de se destacar do fundo. */
  bordered?: boolean;
}

/**
 * Botão só com ícone, 56×56 px. É um <button> nativo de propósito: Enter e
 * Espaço funcionam sem nós escrevermos nada.
 */
export function IconButton({
  icon,
  label,
  onClick,
  bordered = false,
  className,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type="button"
      className={cx('flos-icon-btn', bordered && 'flos-icon-btn--bordered', className)}
      aria-label={label}
      title={label}
      onClick={onClick}
      {...rest}
    >
      <span className="flos-icon" aria-hidden="true">
        {icon}
      </span>
    </button>
  );
}
